// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportFilterDto } from './IReportFilterDto';
import {
    IReportFilterDtoFromJSON,
    IReportFilterDtoFromJSONTyped,
    IReportFilterDtoToJSON,
    IReportFilterDtoToJSONTyped,
} from './IReportFilterDto';

/**
 * 
 * @export
 * @interface IReportResultResponseDto
 */
export interface IReportResultResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IReportResultResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReportResultResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReportResultResponseDto
     */
    report_type?: IReportResultResponseDtoReportTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReportResultResponseDto
     */
    report_group_type?: IReportResultResponseDtoReportGroupTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IReportResultResponseDto
     */
    generation_date?: Date;
    /**
     * 
     * @type {IReportFilterDto}
     * @memberof IReportResultResponseDto
     */
    report_filter?: IReportFilterDto;
    /**
     * 
     * @type {string}
     * @memberof IReportResultResponseDto
     */
    file_url?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IReportResultResponseDto
     */
    plan_names?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum IReportResultResponseDtoReportTypeEnum {
    PARTICIPANT_ACCOUNT_ACTIVITY = 'PARTICIPANT_ACCOUNT_ACTIVITY',
    PAYROLL_CONTRIBUTIONS = 'PAYROLL_CONTRIBUTIONS',
    EMPLOYEE_DEMOGRAPHICS = 'EMPLOYEE_DEMOGRAPHICS',
    CLAIM_ACTIVITY = 'CLAIM_ACTIVITY',
    FORFEITURE = 'FORFEITURE',
    HEALTH_PLAN_ENROLLMENT = 'HEALTH_PLAN_ENROLLMENT',
    CARD_STATUS = 'CARD_STATUS',
    CIP_STATUS = 'CIP_STATUS',
    REPLENISHMENT_INVOICE = 'REPLENISHMENT_INVOICE',
    CONTRIBUTION_INVOICE = 'CONTRIBUTION_INVOICE',
    PREFUND_INVOICE = 'PREFUND_INVOICE',
    PLAN_OMNIBUS_BALANCE = 'PLAN_OMNIBUS_BALANCE',
    UNDELIVERABLE_ADDRESS = 'UNDELIVERABLE_ADDRESS',
    DELINQUENT_CLAIMS = 'DELINQUENT_CLAIMS'
}
/**
* @export
* @enum {string}
*/
export enum IReportResultResponseDtoReportGroupTypeEnum {
    SUMMARY = 'SUMMARY',
    BREAKDOWN = 'BREAKDOWN'
}


/**
 * Check if a given object implements the IReportResultResponseDto interface.
 */
export function instanceOfIReportResultResponseDto(value: object): value is IReportResultResponseDto {
    return true;
}

export function IReportResultResponseDtoFromJSON(json: any): IReportResultResponseDto {
    return IReportResultResponseDtoFromJSONTyped(json, false);
}

export function IReportResultResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportResultResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'report_type': json['report_type'] == null ? undefined : json['report_type'],
        'report_group_type': json['report_group_type'] == null ? undefined : json['report_group_type'],
        'generation_date': json['generation_date'] == null ? undefined : (new Date(json['generation_date'])),
        'report_filter': json['report_filter'] == null ? undefined : IReportFilterDtoFromJSON(json['report_filter']),
        'file_url': json['file_url'] == null ? undefined : json['file_url'],
        'plan_names': json['plan_names'] == null ? undefined : json['plan_names'],
    };
}

export function IReportResultResponseDtoToJSON(json: any): IReportResultResponseDto {
    return IReportResultResponseDtoToJSONTyped(json, false);
}

export function IReportResultResponseDtoToJSONTyped(value?: IReportResultResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'report_type': value['report_type'],
        'report_group_type': value['report_group_type'],
        'generation_date': value['generation_date'] == null ? undefined : ((value['generation_date']).toISOString().substring(0,10)),
        'report_filter': IReportFilterDtoToJSON(value['report_filter']),
        'file_url': value['file_url'],
        'plan_names': value['plan_names'],
    };
}

